function init_hallninja(from_php){
    if(!from_php.girl_id){
        return false;
    }
    if(_ON_DEV){
        console.log(from_php.game_conf);
    }
    var main=$(".place.hallninja");
    main.css({"background-color":"white",color:"black"});
    if(typeof from_php.girl_id=="undefined" || from_php.girl_id==0){
        return false;
    }
    var gameCanv=main.find("#girlGameJsCanvas");
    _mySound.playSound("hall_back");

    var semaphoreSuit= new mySemaphore();

    var girl_id=intval(from_php.girl_id);
    var gameInitObj=new afterInit();

    var timeIndexArr={
        "ajax":_moduleTimeHandler.getNewIndex(),
        "wrong":_moduleTimeHandler.getNewIndex(),
        "timeout":_moduleTimeHandler.getNewIndex(),
        "timeout_error":_moduleTimeHandler.getNewIndex()
    };

    var main=$(".place.hallninja");
    var girl_name=$.takeGirlImage(girl_id);
    var gameCover=main.find("#gameCover");
    var gameCoverState=main.find(".stateJS"),gameCoverWin;
    var state_cur="";
    var gameLog=[];
    var secureStr=from_php.secure;
    var ajaxTimeHandler=_moduleTimeHandler.getNewIndex();

    function postAjax(to_send,conf){
        if(typeof conf=="undefined"){
            conf={};
        }
        conf=$.extend({wait:20,onEnd:function(){}},conf);
        if(semaphoreSuit.use()){
            var data_send={girl_id:girl_id,page:"hallninja"};
            data_send=$.extend(data_send,to_send);
            $.mypost('/ajax',data_send, function(res) {
                var data=handleAjaxRes(res),was_clear=0;
                if(typeof data!="undefined" && data){


                    _moduleTimeHandler.setOne(ajaxTimeHandler,function(){
                        if(intval(data.was_ended)>intval(from_php.was_ended)){
                            _mySound.playSound("girl_moan");
                            $.goToLocation("hallanim/"+girl_id+"/1/");
                            return false;
                        }
                        else if(intval(data.was_ended)>0 && data.was_paid==0){
                            $.goToLocation("hallninja/"+girl_id+"/1/");
                            return false;
                        }
                        from_php=$.extend(from_php,data);
                        
                        updateState();

                        semaphoreSuit.clear();
                        conf.onEnd();
                    },conf.wait);

                }

            },"json");
        }
    }

    function updateState(){

        if(from_php.was_paid){
            if(from_php.was_paid==1){
                showState("game_init");
            }
            else{
                showState("game");
            }


        }
        else{
            if(from_php.repeat_val){
                showState("val_lose");

                /*
                 * repeat_val
                 * val_need
                 * was_error
                 *
                 *
                 */

                //can repeat, lose_val
            }
            else if(typeof from_php.res!="undefined"){
                if(from_php.game_conf.state.type=="coin"){
                    showState("coin_win");
                    /*
                     * res:
                     * coin_have
                     * coin_add
                     * coin_need
                     * try_count_have
                     * try_count_add
                     *
                     */
                }
                else{
                    showState("val_win");
                    /*
                     * res:
                     * val_have
                     * val_need
                     *
                     *
                     *
                     */
                }
            }
            else{
                if(from_php.try_count>0){
                    showState("init");
                }
                else{
                    showState("need_try");
                }
            }
        }
    }


    function init(){
        main.find(".butNextLevelStartJS").click(function(){
            _mySound.playSound("button_click");
            postAjax({start_game:1});
        });



        main.find(".buyGirlDateJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            $.payByPremium(premium_count,function(){
                postAjax({buy_date:1});
            });
        });
        main.find(".repeatMoveTriggerJS").click(function(){
            _mySound.playSound("button_click");
           var th=$(this),premium_count=intval(th.attr("data-need"));
           $.payByPremium(premium_count,function(){
                postAjax({buy_repeat:1});
            });
        });

        var gameCanvas=main.find("#girlGameJsCanvas");




        updateState();
    }


    var stateIndex={
        "game":[_moduleTimeHandler.getNewIndex()]
    };
    var stateFun={
        "coin_win":function(win){
            var i,bum,is_premium="",html="";
            for(i=0;i<from_php.res.coin_add_max;i++){
                if(i<from_php.res.coin_add){
                    if(i>=from_php.res.coin_add/2 && from_php.game_conf.bonus1){
                        is_premium=" premium";
                    }
                    html+="<div class='star have"+is_premium+"'></div>";
                }
                else{
                    html+="<div class='star'></div>";
                }
            }
            win.find(".starWrap").html(html);
            if(is_premium){
                win.find(".starWrap").addClass("premium");
            }

            var str="0";
            if(from_php.res.try_count_add>0){
                str="+"+from_php.res.try_count_add;
            }
            win.find(".putRes[data-type='try_count_add']").html(str);
        },
        "val_win":function(win){
            win.find(".putRes[data-type='val_have']").html(numberFormat(from_php.res.val_have,0,0));
            win.find(".putRes[data-type='val_need']").html(numberFormat(from_php.res.val_need,0,0));


        },
        "val_lose":function(win){
            win.find(".reasonJS").html(from_php.langs["fail"+from_php.was_error]);
            win.find(".putRes[data-type='repeat_val']").html(numberFormat(from_php.repeat_val,0,0));
            win.find(".putRes[data-type='val_need']").html(numberFormat(from_php.val_need,0,0));
            var txt;
            if(from_php.repeat_val>=from_php.val_need){
                txt=from_php.langs["boss_fight"];
            }
            else{
                txt=from_php.langs["egg_to_boss"];
               txt=connectVars(txt,['<span class="color">'+(from_php.val_need-from_php.repeat_val)+'</span>'],"#");
            }
            win.find(".failText").html(txt);


            var repeat_type="premium";
            if(from_php.try_count>=from_php.conf_user.currency_repeat){
                repeat_type="currency";
            }
            win.find(".priceCellJS").addClass("hide").filter("[data-price='"+repeat_type+"']").removeClass("hide");
            win.find(".butRepeatJS").off("click.repeat").on("click.repeat",function(){
                var th=$(this),repeat_type=0,repeat_names={"currency":1,"premium":2};
                var repeat_name=th.attr("data-price");
                if(typeof repeat_names[repeat_name]!="undefined"){
                    repeat_type=repeat_names[repeat_name];
                }
                $.goToLocation("hallninja/"+girl_id+"/",{buy_repeat:1,repeat_type:repeat_type})
//                postAjax({buy_repeat:1,repeat_type:repeat_type});
            });
        },
        "init":function(win){


        },
        "need_try":function(win){
            _timerManager.addTimer(".place.hallninja .timerKeyWaitJS",from_php.try_time,1);
        },
        "game":function(win){
            gameCover.addClass("hide");
            main.find(".hideOnGameJS").addClass("hide");
            main.find(".showOnGameJS").removeClass("hide");
            var gameObj;
            gameObj=new ninjaGameHalloween(main.find("#girlGameJsCanvas"),from_php.game_conf,{
                isTest:0,
                onLoad:function(){
                    gameObj.start();
                },
                onLose:function(obj){
                    //{val: 11, reason_id: 2}
                    _mySound.stopSound("hall_cat_claws");
                    postAjax({
                       game_conf:(Base64.encode(secureStr)),
                       val:obj.val,moves:0,
                       was_error:obj.reason_id
                   },{wait:1000});

                },
                onWin:function(obj){
                    //{val: 20}
                    var wait=1000;
                    if(typeof obj.wait!="undefined"){
                        wait=obj.wait;
                    }
                    _mySound.stopSound("hall_cat_claws");
                    postAjax({
                       game_conf:(Base64.encode(secureStr)),
                       val:obj.val,moves:obj.boss,
                       was_error:0
                   },{wait:wait});
                }
            });
            main.find("#girlGameJsCanvas").click(function(e){
//               $.qLog("e ");
//               console.log(e);
            });


        },
        game_init:function(win){
            var canvasPos=[444,250];//jsquery bug workaround;
            var helpPos=[444,210];
            var gameNinja;
            var confBad={
                sprite_conf:{
                    clips:3,
                    frame_duration:200,
                    floop:false
                },
                anim_type:"sprite",
                img:"pumpkin1",
                map_name:"halloween_pumpkin1",
                step_max:0,
                scale_arr:[100,100],
                pos_start:[canvasPos[0],canvasPos[1]],
                onCut:function(obj){
                    this.addFrontObj(myPixiObj.drawCustom,[{
                        sprite_conf:{
                            clips:8,
                            columns:3
                        },
                        anim_type:"sprite",
                        img:"pumpkin_die",
                        step_max:22,
                        scale_arr:[obj.cut_data.scale,obj.cut_data.scale],
                        pos_start:obj.cut_data.pos,pos_end:obj.cut_data.pos
                    }]);
                }
            };




            gameNinja= new cutGame(win.find("#bookGameStartJS"),{
                width:609,
                height:410,
                imagesPreloader:{
                    "puffb":_IMG_SERV+"/gfx/place/girls/ninja/puffblack.png",
                     pumpkin1:_IMG_SERV+"/gfx/place/gameninja/halloween/pumpin/1/ready.png",
                     pumpkin_die:"/gfx/place/gameninja/halloween/pumpin/die/ready.png",
                },
                spinePreloader:{
                    help:_IMG_SERV+"/gfx/place/girls/gamebook/spine_help/skeleton.json",
                    bat:_IMG_SERV+"/gfx/place/gameninja/halloween/bat/all/skeleton.json"
                },
                onLoad:function(){
                    gameNinja.start();

                    var helpObj=gameNinja.addFrontObj(myPixiObj.drawCustom,[{
                        spine_conf:{
                            anim_loop:true,
                            spineResource:gameNinja.takeSpineResources()
                        },
                        anim_type:"spine",
                        step_max:0,
                        img:"help",pos_start:helpPos,pos_end:helpPos,scale_arr:[80,80]
                    }]);
                    _moduleEvents.on("cutGameEvent.init",function(){
                        var log_arr=gameNinja.getLogs();
                        var i,bum,data_cut;
                        for(i in log_arr){
                            bum=log_arr[i];
                            data_cut=bum.cut_data;
                            if(data_cut.type=="egg" || data_cut.type=="bat2"){
                                _mySound.playSound("hall_pumpkin_cut");
                                _moduleEvents.off("cutGameEvent.init");
                                helpObj.step_max=1;
                                postAjax({
                                    show_game:1
                                },{onEnd:function(){
                                    gameNinja.remove();
                                },wait:600});
                                break;
                            }
                        }

                    });
                    gameNinja.addCollisionCustom("egg",confBad);





                }
            });
        }
    };
    function showState(state){
        main.find(".putGameJs[data-type='try']").html(from_php.try_count);
        main.find(".arrSetCountJS").attr("data-count",from_php.try_count);
        _timerManager.addTimer(".place.gameninja .timerKeyWaitJS",from_php.try_time,1);
        _moduleTimeHandler.clear(timeIndexArr.timeout);

        if(state!="game"){
            main.find(".hideOnGameJS").removeClass("hide");
            main.find(".showOnGameJS").addClass("hide");
            gameCover.removeClass("hide");
        }




        gameCoverWin=gameCoverState.addClass("hide").filter("[data-state='"+state+"']").removeClass("hide");
        if(typeof stateFun[state]=="undefined"){
            alert(state+"!");
        }
        var win=main.find(".stateJS[data-state='"+state+"']");
        stateFun[state](win);

        main.find(".textfill").textfill();
        state_cur=state;
    }



    init();

//    showState("game");

//    gameCanv.one("gameReady",function(){
        main.find(".preloadJS").addClass("hide");
        main.find(".preloadAfterJS").removeClass("hide");
        gameInitObj.load();
//    });

    from_php.game_conf.girl_id=from_php.girl_id;

     _moduleEvents.one("moduleClear",function(){
        _mySound.stopSoundAll();
    });


    $.handleBottomMenu();
    $.handleSelect();

}
